<template>
    <app-dialog :title="$t('createUser.title')" :width="getDialogWidth" max-width="75vw" v-bind="$attrs" :value="value" @input="$emit('input', $event)">
        <template v-slot:content>
            <div class="d-flex justify-center align-center pt-4">
                <v-text-field v-model="form.name" :rules="[rules.required]" autocomplete="name" autofocus required dense class="text-field-asterisk mb-2 left-input myprovet-auth-input">
                    <template v-slot:label>
                        <span>{{ $t('userDetails.name') }}&nbsp;</span>
                        <v-icon class="red--text" style="font-size: 0.75rem !important"> mdi-asterisk </v-icon>
                    </template>
                </v-text-field>
            </div>

            <div class="d-flex justify-center">
                <custom-multi-select
                    component="v-autocomplete"
                    :no-data-text="$t('createUser.noClients')"
                    :value="form.branches"
                    :items="branches"
                    item-text="name"
                    item-value="unique_id"
                    :label="$t('createUser.clients')"
                    @selection-change="form.branches = $event"
                    dense
                    chips
                    single-line
                    clearable
                    deletable-chips
                    full-width
                ></custom-multi-select>
            </div>

            <div class="d-flex justify-center mt-2">
                <v-text-field v-model="form.email" :rules="[rules.required, rules.email]" type="email" autocomplete="email" required dense class="text-field-asterisk myprovet-auth-input left-input mb-2" data-cy="email">
                    <template v-slot:label>
                        <span>Email&nbsp;</span>
                        <v-icon class="red--text" style="font-size: 0.75rem !important"> mdi-asterisk </v-icon>
                    </template>
                </v-text-field>
            </div>

            <div class="d-flex justify-center">
                <v-select v-model="form.role" :items="roles" item-text="name" item-value="id" :label="$t('createUser.group')" dense return-object></v-select>
            </div>
        </template>

        <template v-slot:buttons="{}">
            <v-btn text class="myprovet-btn-cancel" @click="$emit('input', false)">{{ $t('common.close') }}</v-btn>
            <v-btn text class="myprovet-btn-ok" @click="finish" :loading="isLoading">{{ $t('sendAccount.send') }}</v-btn>
        </template>
    </app-dialog>
</template>

<script>
import { i18n } from '@/i18n';
import { axios } from '@/Services/Backend';
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';

export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,

            roles: [],
            branches: [],

            form: {
                name: null,
                branches: [],
                company: null,
                email: null,
                telephone: null,
                role: null,
            },

            rules: {
                required: (value) => (value && !!value) || i18n.t('validation.required'),
                email: (value) => value == null || value == '' || /^.+@.+/.test(value) || i18n.t('createUser.invalidEmail'),
            },
        };
    },

    created() {
        axios
            .get('/api/user/request-information')
            .then((response) => {
                this.roles = response.data?.roles ?? [];
                this.branches = response.data?.branches ?? [];
            })
            .catch((error) => {
                console.log(error.response);

                this.showError(
                    error.response?.data?.message ?? //
                        i18n.t('createUser.loadError')
                );
            });
    },

    computed: {
        ...mapStores(useBranchStore),

        getDialogWidth() {
            return this.getResponsiveDialogWidth('75vw', '35vw');
        },
    },

    methods: {
        finish() {
            this.isLoading = true;

            axios
                .post('/api/user/create-request', {
                    branch_id: this.branchStore.branch?.id,
                    name: this.form.name,
                    email: this.form.email,
                    branches: this.form.branches,
                    role: this.form.role?.name,
                })
                .then(() => {
                    this.isLoading = false;

                    this.showSuccess(this.$t('createUser.sent'));
                    this.$emit('input', false); // Close the dialog.
                })
                .catch((error) => {
                    this.isLoading = false;

                    this.showError(
                        error?.response?.data?.message ?? //
                            i18n.t('createUser.sendError')
                    );
                });
        },
    },
};
</script>
